<template>
  <div id="lookup-fields">
    <h1>Lookup Data Management</h1>
    <div class="upload-form">
      <p>
        To update Countries and Questions data, select a json file with either data below then click on the Update
        button.
      </p>
      <input
        type="file"
        @change="loadTextFromFile"
        accept=".json"
        :disabled="isLoading"
        ref="uploadInput"
      />
      <a-button @click="upsertData" :disabled="isLoading">Update</a-button>
    </div>
    <div class="buttons">
      <a-button @click="getTable('question')" :disabled="isLoading">View Questions</a-button>
      <a-button @click="getTable('country')" :disabled="isLoading">View Countries</a-button>
    </div>

    <div v-if="items.length > 0" class="record-list" :class="resultsMode">
      <h2>{{ resultsMode }}</h2>
      <ul>
        <li v-for="(item, index) in items" :key="item.key">
          <a
            @click="getResult(index)"
            :disabled="isLoading"
            v-html="
              resultsMode == 'question'
                ? `${item.data.text}<br /><span>${item.key}</span>`
                : item.data.iso2Code + ' - ' + item.data.name
            "
          ></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";

// convenience function that just returns an empty {} if the parsing fails
const parseJson = jsonData => {
  try {
    return JSON.parse(jsonData);
  } catch (e) {
    console.log("unable to parse", jsonData);
    // don't worry about the error
    return null;
  }
};

export default {
  name: "QuestionsCountries",
  data() {
    return {
      isLoading: false,
      isViewResults: false,
      fileList: [],
      headers: {
        authorization: "authorization-text"
      },
      jsonString: "",
      jsonResults: {},
      items: [],
      resultsMode: "question"
    };
  },
  computed: {
    ...mapState(["user", "apiUrl"])
  },
  methods: {
    ...mapActions(["getLookupTable"]),
    loadTextFromFile(ev) {
      const file = ev.target.files[0];
      const reader = new FileReader();

      reader.onload = e => {
        let jsonResult = e.target.result;
        this.jsonString += jsonResult;
      };

      reader.readAsText(file);
    },
    async upsertData() {
      this.isLoading = true;
      const parsedJson = parseJson(this.jsonString);

      // upload if it is a valid json
      if (parsedJson != null) {
        const dataKey =
          "iso2Code" in parsedJson[0] ? "iso2Code" : "questionGuid";
        const hide = this.$message.loading("Update in progress..", 0);
        await axios({
          method: "post",
          url: process.env.VUE_APP_API_SERVER + "/lookup-data",
          headers: {
            Authorization: this.user.signInUserSession.idToken.jwtToken
          },
          params: { action: "UPLOAD_LOOKUP_DATA" },
          data: {
            jsonString: this.jsonString
          }
        })
          .then(res => {
            if (res.data.failedCount == 0) {
              alert(`Uploaded all ${res.data.successCount} items.`);
            } else {
              alert(
                `Uploaded ${res.data.successCount} items. ${res.data.failedCount} failed to load (most likely because of an invalid ${dataKey}).`
              );
            }
            setTimeout(hide, 500);
          })
          .catch(error => {
            alert("A server error occurred. Please try again.");
            console.log(error);
            this.isLoading = false;
            setTimeout(hide, 500);
          });
      } else {
        alert("Invalid json file!");
      }

      this.isLoading = false;
      this.jsonString = "";
      this.$refs.uploadInput.value = "";
    },

    async getTable(dataType) {
      this.resultsMode = dataType;
      this.isLoading = true;
      this.items = [];
      const hide = this.$message.loading("Retrieving data...", 0);

      this.items = await this.getLookupTable(dataType);

      setTimeout(hide, 500);
      this.isLoading = false;
      this.isViewResults = true;
    },

    async getResult(index) {
      alert(JSON.stringify(this.items[index]));
    }
  }
};
</script>

<style lang="scss">
#lookup-fields {
  .upload-form {
    margin-bottom: 40px;
  }
  .upload-btn {
    margin: 0 10px;
  }
  .buttons {
    display: flex;
    margin-bottom: 40px;
    button {
      margin-right: 20px;
    }
  }
  .record-list {
    margin-bottom: 40px;
    h2 {
      text-transform: capitalize;
    }
    ul {
      column-count: 3;
      column-gap: 2em;
      list-style: none;
      font-size: 18px;
    }
    li {
      margin-bottom: 20px;

      span {
        font-size: 16px;
        color: #777;
        font-style: italic;
      }
    }
  }
}
</style>
